import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'

import rootReducer from './store/reducers'

import { combineReducers, createStore } from 'redux';
import deliveryOrderReducer from './store/reducers/DeliveryOrderReducer';

import initialState from './initialTestDb'
import LoadingSpinner from './components/presentational-components/LoadingSpinner';
console.log("InitialState: ")
console.log(initialState)

const store = createStore(rootReducer, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
console.log("STORE: ")
console.log(store.getState())
//window.store = store;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM.render(
    <React.StrictMode >
        <Provider store={store}>
            <BrowserRouter basename={baseUrl}>
                <App />
                <LoadingSpinner task={"Authentifizierung"} area={"AppStart"}/>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
